<template>
    <SubPages class="shop-menus" v-if="current_page_id && sub_pages" :pages="sub_pages" :current_page_id="current_page_id" />
</template>

<script>
import SubPages from '@/components/SubPages.vue';

export default {
    name: 'shop-menus',

    watch: {
        '$route.params': {
            handler(params) {

                this.sub_pages = [];
                this.$ajax.get('pages?slug=shop').then(res => {
                    this.page = res.data[0];
                    
                    this.sub_pages.push({
                        post_title: 'MIMA Online Shop',
                        ID: res.data[0].id,
                        link: '/shop',
                    });

                    if (this.$route.name === 'shop-category') {
                        this.$ajax.get('/get-term/product_cat/' + params.slug).then(r => {
                            this.current_page_id = r.data.term_id;
                            document.title = 'MIMA — ' + this.$decode(r.data.name);
                        });
                    } else {
                        this.current_page_id = res.data[0].id;
                        document.title = 'MIMA — ' + this.$decode(res.data[0].title.rendered);
                    }
                    

                    this.$ajax.get('/product-categories').then(r => {
                        r.data.forEach(item => {
                            this.sub_pages.push(item);
                        });

                        this.$ajax.get('pages?slug=shipping-and-returns').then(res => {
                            if (params.page_slug === 'shipping-and-returns') this.current_page_id = res.data[0].id;
                            res.data.forEach(item => {
                                item.ID = item.id;
                                item.is_page_item = true;
                                item.post_title = item.title.rendered;
                                this.sub_pages.push(item);
                            });
                        });
                    });
                });
            },

            immediate: true,
        }
    },

    components: {
        SubPages,
    },

    data() {
        return {
            current_page_id: false,
            sub_pages: [],
        }
    },

}

</script>
